var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.ready)?_c('div',[_c('v-tour',{ref:"vtour",attrs:{"name":_vm.tour,"callbacks":_vm.Callbacks,"steps":this[_vm.tour+"Steps"],"options":{ highlight: true }}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }